import { Link } from "react-router-dom";

export default function Footer({ contact = {} }) {
  const {
    phone = "[PHONE NUMBER]",
    email = "[EMAIL ADDRESS]",
    whatsapp = "[WHATSAPP NUMBER]",
    address = "Dehradun, Uttarakhand",
  } = contact;
  return (
    <footer className="bg-[#EFEAE4] border-t border-[#2C392F]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2">
            <span className="serif text-3xl text-[#2C392F]">ChiMano</span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#985F47]">House</span>
          </div>
          <p className="mt-4 text-[#4A4D4A] max-w-sm leading-relaxed">
            A private, fully serviced staycation home in Dehradun. Spend a weekend or stay the season.
          </p>
          <p className="mt-6 text-sm text-[#1A1C1A]">{address}</p>
        </div>

        <div className="md:col-span-4 text-sm space-y-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#985F47]">Reach us</div>
          <div className="text-[#1A1C1A]">Phone — {phone}</div>
          <div className="text-[#1A1C1A]">Email — {email}</div>
          <div className="text-[#1A1C1A]">WhatsApp — {whatsapp}</div>
        </div>

        <div className="md:col-span-3 text-sm space-y-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#985F47]">Policies</div>
          <Link
            to="/privacy-policy"
            data-testid="footer-link-privacy"
            className="block text-[#1A1C1A] hover:text-[#985F47]"
          >
            Privacy policy
          </Link>
          <Link
            to="/terms-of-stay"
            data-testid="footer-link-terms"
            className="block text-[#1A1C1A] hover:text-[#985F47]"
          >
            Terms of stay
          </Link>
          <Link
            to="/cancellation-policy"
            data-testid="footer-link-cancellation"
            className="block text-[#1A1C1A] hover:text-[#985F47]"
          >
            Cancellation policy
          </Link>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="block text-[11px] uppercase tracking-[0.3em] text-[#4A4D4A] hover:text-[#985F47] pt-4"
          >
            Admin
          </Link>
        </div>
      </div>
      <div className="border-t border-[#2C392F]/10 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[#4A4D4A]">
          <div>© {new Date().getFullYear()} ChiMano House. All rights reserved.</div>
          <div className="serif italic">Made with care, for slow stays.</div>
        </div>
      </div>
    </footer>
  );
}
